export const AUTH_CHANNEL = "auth";
export const LOGIN_EVENT = "login";
export const LOGOUT_EVENT = "logout";
